import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {addApplicationContextToLocationStorage} from '../../../../../redux/actions';
import {Select} from 'antd';
import {selectAuth} from '../../../../../redux/selectors';

const ContextSelector = ({auth, setApplicationContext})=> {
  const handleChangeContext = value => {
    setApplicationContext(value);
  };

  return (
    <Select
      style={{width: '100%'}}
      defaultValue={auth?.appContext || 'web'}
      onChange={handleChangeContext}
      options={[{value: 'web', label:'Sales Effort'}, {value: 'cmt', label:'CMT'}]} />
  );
};

ContextSelector.propTypes = {
  auth: PropTypes.any,
  setApplicationContext: PropTypes.func.isRequired,
};

const actions = {
  setApplicationContext: addApplicationContextToLocationStorage,
};

const mapState = state => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState, actions)(ContextSelector);
